import { render, staticRenderFns } from "./TrainingServiceDetail.vue?vue&type=template&id=a31aedaa&scoped=true&"
import script from "./TrainingServiceDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingServiceDetail.vue?vue&type=style&index=0&id=a31aedaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31aedaa",
  null
  
)

export default component.exports